import { useSearchParams } from 'react-router';
import { useCallback } from 'react';

export const useUrlSync = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getAllParams = useCallback(() => {
    const params: { [key: string]: string } = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  }, [searchParams]);

  const updateMultipleParams = useCallback(
    (params: { [key: string]: string | undefined }) => {
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        Object.entries(params).forEach(([key, value]) => {
          if (value === '' || value === undefined || value === null || (Array.isArray(value) && value.length === 0)) {
            newParams.delete(key);
          } else {
            newParams.set(key, value);
          }
        });
        return newParams;
      });
    },
    [setSearchParams]
  );

  const removeMultipleParams = useCallback(
    (keys: string[]) => {
      setSearchParams(
        (prev) => {
          const newParams = new URLSearchParams(prev);
          keys.forEach((key) => {
            newParams.delete(key);
          });
          return newParams;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  return {
    getAllParams,
    updateMultipleParams,
    removeMultipleParams,
    searchParams
  };
};
